import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Snackbar,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import "./PackageMapping.css";
import CustomSearch from "../../components/CustomSearch/CustomSearch";
import ListItems from "../../components/ListItems/ListItems";
import PackageTable from "../../components/PackageTable/PackageTable";
import { StyledEngineProvider } from "@mui/material/styles";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../components/Modal/modal";
import CorporateDropDown from "../../components/CorporateDropDown/CorporateDropDown";
import SideBar from "../../components/SideBar/SideBar";
import { URL } from "../../constants/constant";

const PackageMapping = () => {
  const [tests, setTests] = useState([]);
  const [pname, setPName] = useState();
  const [message, setMessage] = useState();
  const [availableTests, setAvailableTests] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [edit, editTests] = useState([]);
  const [availableEditTests, setAvailableEditTests] = useState([]);
  const [selectedCorp, setSelectedCorp] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [corp, setCorp] = useState([]);

  const [rcorp, setRCorp] = useState("");
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUserDetails"));

  const addTest = (test) => {
    test = updateTestValue(test);
    setTests([...tests, test]);
    updateAvailableTests(test.name, test.value, "add");
  };
  const [open, setOpen] = useState(false);

  const handleSnackbar = (clear) => {
    setOpen(true);
    if (clear) {
      setTests([]);
      setPName("");
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const updateTestValue = (test) => {
    let value = test.value;
    for (let i = 0; i < tests.length; i++) {
      if (tests[i].value <= value) value++;
    }
    test.value = value;
    return test;
  };

  const updateAvailableTests = (name, value, command) => {
    if (command === "add") {
      const index = availableTests.indexOf(name);
      availableTests.splice(index, 1);
    }
    if (command === "remove") {
      const value_fix = value;
      for (let i = 0; i < tests.length; i++) {
        if (tests[i].value <= value_fix && tests[i].name !== name) value--;
      }
      availableTests.splice(value - 1, 0, name);
    }
  };

  const getData = async () => {
    let response = await axios.get(
      URL.demystify_url + "subtestMapping/fetchSubtestList/"
    );
    setAvailableTests([...response.data.subtest_list]);
    setAvailableEditTests([...response.data.subtest_list]);
  };

  const getTableData = async () => {
    let response = await axios.get(
      URL.demystify_url + "subtestMapping/fetchPackageMapping/"
    );
    response = response.data.mapping_list;
    for (let i = 0; i < response.length; i++) {
      if (response[i].subtest_mapping === "nan") {
        response[i].subtest_mapping = "";
      }
      response[i].subtest_mapping = response[i].subtest_mapping.replaceAll(
        ",",
        ", "
      );
    }
    setTableData(response);
  };

  const getCorp = async () => {
    let response = await axios.get(
      URL.demystify_url + "profileMapping/fetchRelatedEntitiesList/"
    );
    setCorp(response.data.profile_names);
  };

  useEffect(() => {
    getData();
    getTableData();
    getCorp();
  }, []);

  const removeTest = (name, value) => {
    setTests(tests.filter((test) => test.name !== name));
    updateAvailableTests(name, value, "remove");
  };

  const saveTests = () => {
    if (
      pname === undefined ||
      pname.trim() === "" ||
      tests.length === 0 ||
      selectedCorp.length === 0
    ) {
      alert("Please specify Package Name, Subtests and the Corporate");
      return;
    }
    let testsString = "";
    tests.map((test) => {
      testsString += test.name + ",";
    });
    testsString = testsString.substring(0, testsString.length - 1);

    let data = JSON.stringify({
      package_name: pname.trim(),
      subtest_mapping: testsString,
      relatedEntity: selectedCorp,
      user: loggedInUser.emailId.split("@")[0],
    });

    var config = {
      method: "post",
      url: URL.demystify_url + "subtestMapping/addPackageSubtestMapping/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.success === 1) {
          handleSnackbar(true);
          setMessage("Package mapped succesfully");
          getTableData();
        } else if (response.data.success === 0) {
          handleSnackbar(false);
          setMessage(response.data.message);
        }
      })
      .catch(function (error) {
        alert("Something went wrong, please try again");
        console.log(error);
      });
  };

  const updatePackage = () => {
    if (edit.length === 0) {
      alert("please specify package name and subtests");
      return;
    } else if (rcorp === "") {
      handleSnackbar();
      setMessage("Please enter a valid related entity");
    } else {
      let testsString = "";
      edit.map((test) => {
        testsString += test.name + ",";
      });
      testsString = testsString.substring(0, testsString.length - 1);

      let data = JSON.stringify({
        packageName: selectedRows[0].package_name,
        subtestMapping: testsString,
        user: loggedInUser.emailId.split("@")[0],
        relatedEntity: rcorp,
      });

      var config = {
        method: "post",
        url: URL.demystify_url + "subtestMapping/editPackageMapping/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.success === 1) {
            handleSnackbar(true);
            setMessage("Package Edited succesfully");
            getTableData();
            closeModal();
          } else if (response.data.success === 0) {
            handleSnackbar(false);
            setMessage(response.data.message);
          }
        })
        .catch(function (error) {
          alert(error);
          console.log(error);
        });
    }
  };

  const updateAvailableEditTests = (name, value, command) => {
    if (command === "add") {
      const index = availableEditTests.indexOf(name);
      availableEditTests.splice(index, 1);
    }
    if (command === "remove") {
      const value_fix = value;
      for (let i = 0; i < edit.length; i++) {
        if (edit[i].value <= value_fix && edit[i].name !== name) value--;
      }
      availableEditTests.splice(value - 1, 0, name);
    }
  };

  const updateEditTestValue = (test) => {
    let value = test.value;
    for (let i = 0; i < edit.length; i++) {
      if (edit[i].value <= value) value++;
    }
    test.value = value;
    return test;
  };

  const addEditTest = (test) => {
    test = updateEditTestValue(test);
    editTests([...edit, test]);
    updateAvailableEditTests(test.name, test.value, "add");
  };

  const removeEditTest = (name, value) => {
    editTests(edit.filter((test) => test.name !== name));
    updateAvailableEditTests(name, value, "remove");
  };

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  };

  const closeModal = () => {
    edit.map((test) => {
      let value = test.value;
      const value_fix = value;
      for (let i = 0; i < edit.length; i++) {
        if (edit[i].value <= value_fix && edit[i].name !== test.name) value--;
      }
      availableEditTests.splice(value - 1, 0, test.name);
    });

    setShowModal(false);
  };

  const modalButtonClick = () => {
    if (selectedRows.length <= 0) {
      setOpen(true);
      setMessage("Please select a Package first");
      return;
    }
    setShowModal(true);

    setRCorp(selectedRows[0].relatedEntity);
    const selectedSubTest = removeDuplicates(
      selectedRows.length ? selectedRows[0].subtest_mapping.split(", ") : []
    );
    const data = selectedSubTest
      .filter((sub) => {
        if (!sub.includes("_")) return sub;
      })
      .map((sub) => {
        if (!sub.includes("_")) {
          return { name: sub, value: availableEditTests.indexOf(sub) };
        }
      });
    data.map((test) => {
      let value = test.value;
      for (let i = 0; i < data.length; i++) {
        if (data[i].value <= value) value++;
      }
      test.value = value;
      let index = availableEditTests.indexOf(test.name);
      availableEditTests.splice(index, 1);
    });
    editTests(data);
  };

  return (
    <div className="grid-container-packageMapping">
      <div className="grid-sidebar">
        <SideBar isTechTeam={loggedInUser.isTechTeam} />
      </div>
      <div className="grid-package-table">
        <div className="view-pack">
          <h1> View Packages </h1>
        </div>
        <div className="edit-pack">
          <Box display="flex" marginRight="3%" justifyContent="flex-end">
            <Button onClick={modalButtonClick} variant="contained">
              Edit Package
            </Button>
          </Box>
          <Modal show={showModal} setShow={setShowModal}>
            <ModalHeader>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Edit Package</Typography>
            </ModalHeader>
            <ModalBody>
              <div className="package-name">
                <div
                  className="package-name-child"
                  style={{ justifyContent: "center" }}
                >
                  <div className="pname">
                  <div style={{ textAlign: "center", fontWeight: "700" }}>
                    Package Name:  {" "}
                  </div>
                  <div style={{ textAlign: "center", fontWeight: "700" }}>
                    {selectedRows.length > 0
                      ? selectedRows[0].package_name
                      : undefined}
                  </div>
                  </div>
                  <div className="rel-ent">
                    <div style={{ textAlign: "center", fontWeight: "700" }}>
                      Related Entity:
                    </div>
                    <CorporateDropDown
                      corp={corp}
                      setSelectedCorp={setRCorp}
                      rcorp={rcorp}
                    />
                  </div>
                </div>
              </div>
              <CustomSearch
                addTest={addEditTest}
                tests={edit}
                availableTests={availableEditTests}
              />
              <ListItems tests={edit} removeTest={removeEditTest} />
            </ModalBody>
            <ModalFooter>
              <Button
                variant="contained"
                style={{ marginRight: 50 }}
                onClick={updatePackage}
              >
                Edit
              </Button>
              <Button onClick={closeModal}>Close</Button>
            </ModalFooter>
          </Modal>
        </div>
        <StyledEngineProvider injectFirst>
          <PackageTable
            tableData={tableData}
            setSelectedRows={setSelectedRows}
          />
        </StyledEngineProvider>

        <div className="grid-add-package">
          <h1 style={{ marginTop: 50 }}>Add Package</h1>
          <div className="package-name">
            <div
              className="package-name-child"
              style={{ marginRight: 20, justifyContent: "center" }}
            >
              <Typography
                style={{ textAlign: "center", fontWeight: "700" }}
                variant="h6"
              >
                Package Name
              </Typography>
            </div>

            <div className="package-name-child">
              <TextField
                multiline
                rows={1}
                value={pname}
                onChange={(e) => {
                  setPName(e.target.value);
                }}
                variant="outlined"
                label="Package"
                style={{ width: 300 }}
                className="package-name-child"
              />
            </div>
          </div>
          <CorporateDropDown corp={corp} setSelectedCorp={setSelectedCorp} />
          <CustomSearch
            addTest={addTest}
            tests={tests}
            availableTests={availableTests}
          />
          <ListItems tests={tests} removeTest={removeTest} />
          <Button
            variant="contained"
            style={{ marginTop: 75, marginBottom: 100 }}
            onClick={saveTests}
          >
            Save
          </Button>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            action={action}
            message={message}
          />
        </div>
      </div>
    </div>
  );
};

export default PackageMapping;
